import { render, staticRenderFns } from "./BerthaAIAssistant.vue?vue&type=template&id=d2fc83da"
import script from "./BerthaAIAssistant.vue?vue&type=script&lang=js"
export * from "./BerthaAIAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports